export const louisiana = {
  "22000": "Louisiana",
  "22001": "Acadia Parish",
  "22003": "Allen Parish",
  "22005": "Ascension Parish",
  "22007": "Assumption Parish",
  "22009": "Avoyelles Parish",
  "22011": "Beauregard Parish",
  "22013": "Bienville Parish",
  "22015": "Bossier Parish",
  "22017": "Caddo Parish",
  "22019": "Calcasieu Parish",
  "22021": "Caldwell Parish",
  "22023": "Cameron Parish",
  "22025": "Catahoula Parish",
  "22027": "Claiborne Parish",
  "22029": "Concordia Parish",
  "22031": "De Soto Parish",
  "22033": "East Baton Rouge Parish",
  "22035": "East Carroll Parish",
  "22037": "East Feliciana Parish",
  "22039": "Evangeline Parish",
  "22041": "Franklin Parish",
  "22043": "Grant Parish",
  "22045": "Iberia Parish",
  "22047": "Iberville Parish",
  "22049": "Jackson Parish",
  "22051": "Jefferson Parish",
  "22053": "Jefferson Davis Parish",
  "22055": "Lafayette Parish",
  "22057": "Lafourche Parish",
  "22059": "La Salle Parish",
  "22061": "Lincoln Parish",
  "22063": "Livingston Parish",
  "22065": "Madison Parish",
  "22067": "Morehouse Parish",
  "22069": "Natchitoches Parish",
  "22071": "Orleans Parish",
  "22073": "Ouachita Parish",
  "22075": "Plaquemines Parish",
  "22077": "Pointe Coupee Parish",
  "22079": "Rapides Parish",
  "22081": "Red River Parish",
  "22083": "Richland Parish",
  "22085": "Sabine Parish",
  "22087": "St. Bernard Parish",
  "22089": "St. Charles Parish",
  "22091": "St. Helena Parish",
  "22093": "St. James Parish",
  "22095": "St. John the Baptist Parish",
  "22097": "St. Landry Parish",
  "22099": "St. Martin Parish",
  "22101": "St. Mary Parish",
  "22103": "St. Tammany Parish",
  "22105": "Tangipahoa Parish",
  "22107": "Tensas Parish",
  "22109": "Terrebonne Parish",
  "22111": "Union Parish",
  "22113": "Vermilion Parish",
  "22115": "Vernon Parish",
  "22117": "Washington Parish",
  "22119": "Webster Parish",
  "22121": "West Baton Rouge Parish",
  "22123": "West Carroll Parish",
  "22125": "West Feliciana Parish",
  "22127": "Winn Parish",
};
